import Button from "./Button";
import Icon from "./Icon";

function Modal({
  isOpen,
  title,
  children,
  onClose,
  headerActions = null,
  closeLabel = "Close",
  closeIconOnly = true,
  panelClassName = "",
  bodyClassName = ""
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[2200] flex items-end sm:items-center justify-center bg-black/35 px-0 sm:px-4">
      <div className={`ui-card w-full max-w-xl animate-fade-up rounded-t-2xl sm:rounded-2xl max-h-[90vh] overflow-y-auto ${panelClassName}`.trim()}>
        <div className="flex items-start justify-between gap-4">
          <h2 className="ui-title text-xl">{title}</h2>
          <div className="flex items-center gap-2">
            {headerActions}
            <Button
              type="button"
              variant="ghost"
              onClick={onClose}
              aria-label={closeLabel}
              title={closeLabel}
              className={
                closeIconOnly
                  ? "dana-modal-header-btn h-10 w-10 rounded-lg border border-app-line bg-white p-0 text-app-ink hover:bg-slate-50"
                  : ""
              }
            >
              {closeIconOnly ? <Icon name="x" className="h-8 w-8" /> : closeLabel}
            </Button>
          </div>
        </div>
        <div className={`mt-3 ${bodyClassName}`.trim()}>{children}</div>
      </div>
    </div>
  );
}

export default Modal;
